import React from 'react'
import cx from 'classnames'

import { WarningIcon } from '@components/icons/WarningIcon'
import { TextAreaProps } from './interface'

export function TextArea({
  className,
  value,
  showLength,
  maxLength,
  ...props
}: TextAreaProps) {
  return (
    <div className='w-full'>
      <textarea
        className={cx(
          'p-[10px] border border-gray-3 dark:border-purple rounded-[8px] w-full outline-none resize-none focus:border-primary focus:text-primary dark:text-dark-10 dark:bg-dark-8',
          className
        )}
        value={value}
        data-test={props.name}
        {...props}
      />
      {showLength ? (
        <div className='flex space-x-[4px] justify-end mobile:justify-start'>
          <span>
            <WarningIcon className='text-primary' width='16' height='16' />
          </span>
          <span className='font-light text-[12px] text-secondary-1'>
            {`ไม่เกิน ${maxLength?.toLocaleString()} ตัวอักษร (${
              value?.toString().length.toLocaleString() || 0
            } /
            ${maxLength?.toLocaleString()})`}
          </span>
        </div>
      ) : null}
    </div>
  )
}
